import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import styles from './horariosvalores_diegoftv00.module.scss';
import { FaArrowLeft } from 'react-icons/fa';

const WHATSAPP_NUMBER = '5517988393564';

const PLANOS = [
    { label: '1x na semana', valor: 'R$ 120,00' },
    { label: '2x na semana', valor: 'R$ 140,00' },
    { label: 'Aulas avulsas', valor: 'R$ 35,00' },
];

const HORARIOS = [
    { dia: 'Segunda-feira', hora: '06:00 às 19:00' },
    { dia: 'Terça-feira', hora: '06:00 às 19:00' },
    { dia: 'Quarta-feira', hora: '06:00 às 19:00' },
    { dia: 'Quinta-feira', hora: '06:00 às 19:00' },
    { dia: 'Sexta-feira', hora: '06:00 às 19:00' },
    { dia: 'Sábado', hora: '05:00 às 10:00' },
];

function whatsappUrl(mensagem: string) {
    return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(mensagem)}`;
}

const Horariosvalores_diegoftv00: React.FC = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className={styles.horariosvalores_diegoftv00}>
            <div className={styles.pageWrapper}>
                <div className={styles.horariosvalores_diegoftv00}>
                    <div className={styles.header}>
                        <Link to="/diegoftv00" className={styles.backButton} aria-label="Voltar">
                            <FaArrowLeft />
                        </Link>
                        <h1 className={styles.title}>Horários e Valores</h1>
                    </div>

                    <div className={styles.section}>
                        <h2 className={styles.sectionTitle}>Planos mensais</h2>
                        <ul className={styles.planosList}>
                            {PLANOS.map((item, index) => (
                                <li key={index} className={styles.planoItem}>
                                    <span className={styles.planoLabel}>{item.label}</span>
                                    <span className={styles.planoValor}>{item.valor}</span>
                                </li>
                            ))}
                        </ul>
                        <a
                            href={whatsappUrl('Olá! Gostaria de adquirir um plano de aulas.')}
                            className={styles.cta}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Quero um plano - WhatsApp
                        </a>
                    </div>

                    <div className={styles.section}>
                        <h2 className={styles.sectionTitle}>Horários disponíveis</h2>
                        <div className={styles.diasList}>
                            {HORARIOS.map((dia, index) => (
                                <div key={index} className={styles.diaCard}>
                                    <div className={styles.diaNome}>{dia.dia}</div>
                                    <ul className={styles.turmasList}>
                                        <li className={styles.turmaItem}>
                                            <span className={styles.turmaHora}>{dia.hora}</span>
                                        </li>
                                    </ul>
                                </div>
                            ))}
                        </div>
                        <a
                            href={whatsappUrl('Olá! Gostaria de agendar um horário de aula.')}
                            className={styles.cta}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Agendar horário - WhatsApp
                        </a>
                    </div>

                    <div className={styles.catalogoWrap}>
                        <img
                            src={require('./src/catalogo.png')}
                            alt="Catálogo - Horários e planos"
                            className={styles.catalogoImage}
                        />
                    </div>

                    <div className={styles.footer}>
                        <img
                            src={require('./src/logo.png')}
                            alt="DS"
                            className={styles.footerLogo}
                        />
                        <img
                            src={require('./src/logo_topsoccer.png')}
                            alt="Top Soccer"
                            className={styles.footerLogo}
                        />
                    </div>

                </div>
            </div>
        </div>
    );
};

export default Horariosvalores_diegoftv00;
